export const addDecimalPoints = num => {
	var inputValue = num
		.toString()
		.replace(".", "")
		.split("")
		.reverse()
		.join("");
	var newValue = "";
	for (let i = 0; i < inputValue.length; i++) {
		if (i > 0 && i % 3 == 0) newValue += ".";

		newValue += inputValue[i];
	}
	return newValue
		.split("")
		.reverse()
		.join("");
};

/**
 * Converte um número 1234 em R$ 1.234
 * @param {Number} value valor a ser convertido
 * @param {String} [currency] símbolo da moeda
 * @returns {String}
 */
export const formatCurrency = (value, currency = "") => {
	if (value == undefined) return; //TODO
	let valueParse = parseFloat(value.toString().replace(",", "."))
		.toFixed(2)
		.toString()
		.split(".");
	return currency + addDecimalPoints(valueParse[0]) + "," + pad(valueParse[1]);
};

/**
 * Aplica máscara em números inteiros. ex: 3000000 -> 3.000.000
 * @param {Number} number Numero inteiro
 */
export const intFormat = number => {
	if (number == undefined) return 0; //TODO
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const pad = (n, width = 2, z) => {
	z = z || "0";
	n = n + "";
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

export const floatFormat = number => {
	let newNumber = number.replace(",", ".");
	newNumber = parseFloat(newNumber.replace(/[^\d.]/g, ""));
	return newNumber;
};

// Mask para manter apenas números no campo
export const formatOnlyNumbers = number => {
	return number
		.match(/[0-9]+/g)
		.join("")
		.toString();
};

export const formatPaymentDeadline = (paymentDeadline, paymentScheduleType) => {
    if (!paymentDeadline || paymentDeadline <= 0) {
        return null;
    }
    const daysLabel = paymentDeadline > 1 ? 'dias' : 'dia';
    const typeLabel = paymentScheduleType === 'WORKING_DAYS' ? (paymentDeadline > 1 ? 'úteis' : 'útil') : (paymentDeadline > 1 ? 'corridos' : 'corrido');

    return `${paymentDeadline} ${daysLabel} ${typeLabel}`;
};
